<template>
  <div id="main" class="app-main">
    <router-view></router-view>
    <a href="https://beian.miit.gov.cn/" target="_blank" class="bottom_a"
      >苏ICP备2021049748号-2</a
    >
  </div>
</template>

<script>
//import config from '@/../config'

import * as dd from "dingtalk-jsapi";

export default {
  components: {},
  data() {
    return {
      url: window.location.protocol + "//" + document.domain,
      theme: this.$store.state.app.themeColor,
    };
  },
  async created() {
    $utils.data.set("UserInfo", "Calling", false);
    await this.selectMainType();
    if (!window.localStorage.getItem("customerId")) {
      this.getPar("customerId");
    }
    let pcFun = this.isPCFun();
    window.localStorage.setItem("pcFun", pcFun);
    if (pcFun == 2 && window.localStorage.getItem("mainType") == "2") {
      let str = "code";

      //如果有code 则登录
      await this.getInfo();

      if (window.location.href.indexOf(str) == -1) {
        let customerId = window.localStorage.getItem("customerId");
        let id = parseInt(customerId);
        await this.getQyConfig(id);
      } else {
        let code = this.getUrlValue("code");
        let customerId = window.localStorage.getItem("customerId");
        let id = parseInt(customerId);
        let MaintainerToken = global.$utils.data.get("", "token");

        if (!MaintainerToken || MaintainerToken == undefined) {
          await this.loginNew(code, id);
        } else {
          await this.getInfo();
          return;
        }
      }
    } else if (pcFun == 2 && window.localStorage.getItem("mainType") == "3") {
      let str = "code";
      //如果有code 则登录

      await this.getCusInfo();
      if (window.location.href.indexOf(str) == -1) {
        let customerId = window.localStorage.getItem("customerId");
        let id = parseInt(customerId);
        await this.getCusConfig(id);
      } else {
        let code = this.getUrlValue("code");
        let customerId = window.localStorage.getItem("customerId");
        let id = parseInt(customerId);
        let MaintainerToken = global.$utils.data.get("", "token");
        if (!MaintainerToken || MaintainerToken == undefined) {
          await this.loginCus(code, id);
        }
      }
    } else if (pcFun == 5 && window.localStorage.getItem("mainType") == "3") {
      await this.getCusInfo();
      await this.getDingAuthInfo();
      let customerId = parseInt(window.localStorage.getItem("customerId"));
      let corpId = global.$utils.data.get("", "corpId");
      let result = await this.getCode(corpId);
      let MaintainerToken = global.$utils.data.get("", "token");
      if (!MaintainerToken || MaintainerToken == undefined) {
        await this.loginDDCus(result.code, customerId);
      } else {
        await this.getCusInfo();
        return;
      }
    } else if (pcFun == 5 && window.localStorage.getItem("mainType") == "2") {
      await this.getInfo();
      await this.getDingAuthWeiXiu();
      let customerId = parseInt(window.localStorage.getItem("customerId"));
      let corpId = global.$utils.data.get("", "corpId");
      let result = await this.getCode(corpId);
      let MaintainerToken = global.$utils.data.get("", "token");
      if (!MaintainerToken || MaintainerToken == undefined) {
        await this.loginDDNew(result.code, customerId);
      } else {
        await this.getInfo();
        return;
      }
    }

    //检测登录状态
    let MaintainerToken = global.$utils.data.get("", "token");

    if (!MaintainerToken) {
      if (window.localStorage.getItem("token") == '{"data":""}') {
        if (this.isPCFun() == 2 || this.isPCFun() == 5) {
          location.replace(location.href);
          return false;
        } else {
          // 登录
          $utils.url.push({ name: "login" });
          return false;
        }
      }
    }
    // 检测登录状态
    $utils.api
      .load("authCheck", {}, "post", {
        toast: false,
        toasterror: false,
        loading: false,
        loadingtext: "Loading",
        login: false,
      })
      .then((res) => {
        if (res.code != 200) {
          if (this.isPCFun() == 2 || this.isPCFun() == 5) {
            location.replace(location.href);
            return false;
          } else {
            // 登录
            $utils.url.push({ name: "login" });
            return false;
          }
        }
        if (res.user && res.auths) {
          const last_login_time = $utils.time.format(res.user.loginDate || "");
          $utils.data.set("auth", "last_login_time", last_login_time);
          $utils.data.set("auth", "auths", []);
          $utils.data.set("auth", "username", res.user.nickName);
          $utils.data.set("auth", "userName", res.user.userName);
          $utils.data.set("auth", "suid", res.user.userId);
          $utils.data.set("auth", "uid", res.user.userId);
          $utils.data.set("auth", "uname", res.user.nickName);
          $utils.data.set("auth", "isAdmin", res.user.isAdmin);
          $utils.data.set(
            "auth",
            "avatar",
            $utils.image.load(res.user.avatar) ||
              require("@/assets/img/useravatar.jpg")
          );
          $utils.data.set("auth", "auths", res.auths);
          let auths = res.auths;
          let workEditCount = 0;
          let commonEditCount = 0;
          for (let i = 0; i < auths.length; i++) {
            if (auths[i].url == "/system/workOrder/edit") {
              workEditCount++;
            }
            if (auths[i].url == "system/commondescr/add") {
              commonEditCount++;
            }
          }
          $utils.data.set("auth", "authsWorkEdit", workEditCount);
          $utils.data.set("auth", "authsCommonEdit", commonEditCount);
          $utils.data.set("auth", "makeMain", res.makeMain);
          $utils.data.set("auth", "deskId", res.user.deskId);
          global.$utils.data.set("auth", "makeMain", res.makeMain);
          // const last_login_time = $utils.time.format(res.data.last_login_time || '')
          // $utils.data.set('auth', 'last_login_time', last_login_time)
          // $utils.data.set('auth', 'auths', [])
          // $utils.data.set('auth', 'username', res.data.username)
          // $utils.data.set('auth', 'suid', res.data.suid)
          // $utils.data.set('auth', 'uid', res.data.uid)
          // $utils.data.set('auth', 'uname', res.data.uname)
          // $utils.data.set('auth', 'avatar', $utils.image.load(res.data.head) || require('@/assets/img/useravatar.jpg'))
          // $utils.data.set('auth', 'auths', res.data.auths)
          // $utils.data.set('auth', 'is_system', res.data.is_admin)
          // $utils.data.set('auth', 'is_admin', res.data.is_admin)
          // $utils.data.set('auth', 'is_all_order', res.data.is_all_order)
          // $utils.data.set('auth', 'shop_id', res.data.shop_id)
          // $utils.data.set('auth', 'shop_name', res.data.shop_name)
          // 强制刷新页面 否则左侧路由无法更新
          this.$store.commit("updateMenulist");
        } else {
          $utils.toast.error(res.message);
        }
      });
  },
  mounted() {},
  methods: {
    async getCusInfo() {
      let res;
      try {
        res = await $utils.api.load("/admin/getInfo", {}, "get");
        if (!res.user) {
          if (this.isPCFun() == 2) {
            let str = "code";
            if (window.location.href.indexOf(str) == -1) {
              let customerId = window.localStorage.getItem("customerId");
              let id = parseInt(customerId);
              await this.getCusConfig(id);
            } else {
              let code = this.getUrlValue("code");
              let customerId = window.localStorage.getItem("customerId");
              let id = parseInt(customerId);
              let MaintainerToken = global.$utils.data.get("", "token");
              if (!MaintainerToken || MaintainerToken == undefined) {
                await this.loginCus(code, id);
              }
            }
          } else if (this.isPCFun() == 5) {
            await this.getDingAuthInfo();
            let customerId = parseInt(
              window.localStorage.getItem("customerId")
            );
            let corpId = global.$utils.data.get("", "corpId");
            let result = await this.getCode(corpId);
            let MaintainerToken = global.$utils.data.get("", "token");
            if (!MaintainerToken || MaintainerToken == undefined) {
              await this.loginDDCus(result.code, customerId);
            }
          }
        }
        if (res.code == 200) {
          if (res.user.userAllType.indexOf("1") != -1) {
            window.localStorage.setItem("mainType", "1");
            let thirdType;
            if (this.isPCFun() == 2) {
              thirdType = 2;
            } else if (this.isPCFun() == 5) {
              thirdType = 3;
            }
            await this.ajaxLogin(res.user.phonenumber, thirdType);
            return;
          }
        }
      } catch (e) {
        // if (this.isPCFun() == 2){
        //   let customerId = window.localStorage.getItem("customerId");
        //   let id = parseInt(customerId)
        //   await this.getCusConfig(id);
        //   let code = this.getUrlValue("code");
        //   let MaintainerToken = global.$utils.data.get("","token")
        //   if (!MaintainerToken || MaintainerToken == undefined){
        //     await this.loginCus(code, id);
        //   }
        //
        // }else if(this.isPCFun() == 5){
        //   await this.getDingAuthInfo()
        //   let customerId = window.localStorage.getItem("customerId");
        //   let corpId = global.$utils.data.get("", "corpId");
        //   let result = await this.getCode(corpId)
        //   let MaintainerToken = global.$utils.data.get("","token")
        //   if (!MaintainerToken || MaintainerToken == undefined) {
        //     await this.loginDDCus(result.code, customerId)
        //   }
        // }
        // return
      }
    },
    async getInfo() {
      let res;
      try {
        res = await $utils.api.load("/admin/getInfo", {}, "get");
        if (!res.user) {
          if (this.isPCFun() == 2) {
            let str = "code";
            if (window.location.href.indexOf(str) == -1) {
              let customerId = window.localStorage.getItem("customerId");
              let id = parseInt(customerId);
              await this.getQyConfig(id);
            } else {
              let code = this.getUrlValue("code");
              let customerId = window.localStorage.getItem("customerId");
              let id = parseInt(customerId);
              let MaintainerToken = global.$utils.data.get("", "token");

              if (!MaintainerToken || MaintainerToken == undefined) {
                await this.loginNew(code, id);
              }
            }
          } else if (this.isPCFun() == 5) {
            await this.getDingAuthWeiXiu();
            let customerId = parseInt(
              window.localStorage.getItem("customerId")
            );
            let corpId = global.$utils.data.get("", "corpId");
            let result = await this.getCode(corpId);
            await this.loginDDNew(result.code, customerId);
          }
        }
        if (res.code == 200) {
          if (res.user.userAllType.indexOf("1") != -1) {
            window.localStorage.setItem("mainType", "1");
            let thirdType;
            if (this.isPCFun() == 2) {
              thirdType = 2;
            } else if (this.isPCFun() == 5) {
              thirdType = 3;
            }
            await this.ajaxLogin(res.user.phonenumber, thirdType);
            return;
          }
        }
      } catch (e) {
        if (this.isPCFun() == 2) {
          let str = "code";
          if (window.location.href.indexOf(str) == -1) {
            let customerId = window.localStorage.getItem("customerId");
            let id = parseInt(customerId);
            await this.getQyConfig(id);
          } else {
            let code = this.getUrlValue("code");
            let customerId = window.localStorage.getItem("customerId");
            let id = parseInt(customerId);
            let MaintainerToken = global.$utils.data.get("", "token");

            if (!MaintainerToken || MaintainerToken == undefined) {
              await this.loginNew(code, id);
            }
          }
        } else if (this.isPCFun() == 5) {
          await this.getDingAuthWeiXiu();
          let customerId = parseInt(window.localStorage.getItem("customerId"));
          let corpId = global.$utils.data.get("", "corpId");
          let result = await this.getCode(corpId);
          await this.loginDDNew(result.code, customerId);
        }
      }
    },
    async getCusConfig(id) {
      try {
        let d = { customerId: id };
        let res = await global.$utils.api.load(
          "/customer/getQyConfig",
          d,
          "get"
        );

        if (res) {
          let item = res.data;
          //构造网页授权链接
          // appaass.hi-eweibao.com?cid=12
          let uurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
            item.configKey
          }&redirect_uri=${encodeURIComponent(
            this.url
          )}&response_type=code&scope=snsapi_privateinfo&agentid=${
            item.remark
          }&state=wxwork#wechat_redirect`;
          window.location.href = uurl;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async loginNew(obj, customerId) {
      let params = {
        code: obj,
        customerId: customerId,
        thirdType: 2,
      };
      let thirdType;
      if (this.isPCFun() == 2) {
        thirdType = 2;
      } else if (this.isPCFun() == 5) {
        thirdType = 3;
      }
      let res;
      try {
        res = await $utils.api.load("/maintainer/login", params, "post");
        if (res.code == 200) {
          if (res.user.userAllType.indexOf("1") != -1) {
            await this.ajaxLogin(res.user.phonenumber, thirdType);
            return;
          }
          let token = res.token || "";
          global.$utils.data.set("", "token", token);
          window.location.href = `${this.url}/#/await_weixiu`;
          return;
        } else {
          await this.ajaxLogin(res.data, thirdType);
        }
        if (res.code == 403 || res.code == 500) {
          await this.ajaxLogin(res.data, thirdType);
        }
      } catch (e) {
        await this.ajaxLogin(res.data, thirdType);
      }
    },
    async ajaxLogin(phone, thirdType) {
      let id = window.localStorage.getItem("customerId");
      let customerId = parseInt(id);
      let params = {
        phoneNumber: phone,
        customerId: customerId,
        thirdType: thirdType,
      };
      window.localStorage.setItem("mainType", "1");
      global.$utils.data.set("", "token", "");
      let res = await $utils.api.load("authLogin", params, "post", {
        toast: false,
        toasterror: false,
        loading: false,
        loadingtext: "Loading",
        login: false,
      });
      try {
        if (res.code == 200) {
          $utils.toast.text(res.msg);
          const last_login_time = $utils.time.format(res.user.loginDate || "");
          $utils.data.set("auth", "last_login_time", last_login_time);
          $utils.data.set("auth", "auths", []);
          $utils.data.set("auth", "username", res.user.nickName);
          $utils.data.set("auth", "userName", res.user.userName);
          $utils.data.set("auth", "suid", res.user.userId);
          $utils.data.set("auth", "uid", res.user.userId);
          $utils.data.set("auth", "uname", res.user.nickName);
          $utils.data.set(
            "auth",
            "avatar",
            $utils.image.load(res.user.avatar) ||
              require("@/assets/img/useravatar.jpg")
          );
          $utils.data.set("auth", "auths", res.auths);

          // $utils.data.set('auth', 'is_system', res.data.is_admin)
          // $utils.data.set('auth', 'is_admin', res.data.is_admin)
          // $utils.data.set('auth', 'is_all_order', res.data.is_all_order)
          // $utils.data.set('auth', 'shop_id', res.data.shop_id)
          // $utils.data.set('auth', 'shop_name', res.data.shop_name)
          // 强制刷新页面 否则左侧路由无法更新
          this.$store.commit("updateMenulist");

          // if (res.makeMain == "1"){
          $utils.url.push({ path: "/index" });
          // $utils.url.push({ path: "/allIndex" });
          // }else if (res.makeMain == "2"){
          //   $utils.url.push({ path: "/workOrder_weixiu" });
          // }else if (res.makeMain == "3"){
          //   $utils.url.push({ path: "/workOrder_cus" });
          // }
          // window.location.reload(true);
        } else {
          await this.ajaxLogin(phone, thirdType);
        }
      } catch {
        window.location.reload(true);
      }
    },
    async getQyConfig(id) {
      try {
        let d = { customerId: id };
        let res = await global.$utils.api.load(
          "/maintainer/getQyConfig",
          d,
          "get",
          false,
          "urlencoded"
        );
        if (res) {
          let item = res.data;
          //构造网页授权链接
          let maurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
            item.configKey
          }&redirect_uri=${encodeURIComponent(
            this.url
          )}&response_type=code&scope=snsapi_privateinfo&agentid=${
            item.remark
          }&state=wxwork#wechat_redirect`;
          window.location.href = maurl;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async loginCus(obj, customerId) {
      let params = {
        code: obj,
        customerId: customerId,
        thirdType: 2,
      };
      let thirdType;
      if (this.isPCFun() == 2) {
        thirdType = 2;
      } else if (this.isPCFun() == 5) {
        thirdType = 3;
      }
      let res = await $utils.api.load("/customer/login", params, "post");
      try {
        if (res.code == 200) {
          if (res.user.userAllType.indexOf("1") != -1) {
            await this.ajaxLogin(res.user.phonenumber, thirdType);
            return;
          }
          let token = res.token || "";
          global.$utils.data.set("", "token", token);
          // $utils.toast.text("登录成功！");
          window.location.href = `${this.url}/#/cusIndex`;
          return;
        } else {
          await this.ajaxLogin(res.data, thirdType);
        }
        if (res.code == 403 || res.code == 500) {
          await this.ajaxLogin(res.data, thirdType);
        }
      } catch (e) {
        await this.ajaxLogin(res.data, thirdType);
      }
    },
    async getCode(corpid) {
      return new Promise((resolve, reject) => {
        dd.runtime.permission.requestAuthCode({
          corpId: corpid,
          onSuccess: function (result) {
            resolve(result);
          },
          onFail: function (err) {
            reject(err);
          },
        });
      });
    },
    async getDingAuthWeiXiu() {
      try {
        let url = window.location.href.split("#")[0];
        let data = {};
        data.url = url;
        data.customerId = parseInt(window.localStorage.getItem("customerId"));
        let res = await $utils.api.load(
          "/maintainer/getDDAuthInfo",
          data,
          "post"
        );
        if (res.code == 200) {
          global.$utils.data.set("", "corpId", res.corpId);
        }
      } catch (err) {
        console.log(err);
      }
    },
    //获取钉钉api请求权限配置
    async getDingAuthInfo() {
      try {
        let url = window.location.href.split("#")[0];
        let data = {};
        data.url = url;
        data.customerId = parseInt(window.localStorage.getItem("customerId"));
        let res = await $utils.api.load(
          "/customer/getDDAuthInfo",
          data,
          "post"
        );
        if (res.code == 200) {
          global.$utils.data.set("", "corpId", res.corpId);
        }
      } catch (err) {
        console.log(err);
      }
    },

    async loginDDNew(obj, customerId) {
      let params = {
        code: obj,
        customerId: customerId,
        thirdType: 3,
      };
      let res = await $utils.api.load("/maintainer/login", params, "post");
      try {
        if (res.code == 200) {
          let token = res.token || "";
          global.$utils.data.set("", "token", token);
          // $utils.toast.text("登录成功！");
          // $utils.url.push({ path: "/index" });
          window.location.href = `${this.url}/#/await_weixiu`;
          return;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async loginDDCus(obj, customerId) {
      let params = {
        code: obj,
        customerId: customerId,
        thirdType: 3,
      };

      let res = await $utils.api.load("/customer/login", params, "post");

      try {
        if (res.code == 200) {
          let token = res.token || "";
          global.$utils.data.set("", "token", token);
          // $utils.toast.text("登录成功！");
          window.location.href = `${this.url}/#/cusIndex`;
        }
      } catch (e) {
        console.log(e);
      }
    },

    //截取url中的code
    getUrlValue(kValue) {
      let url = window.location.href;
      let reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName == kValue) {
          return obj[keyName];
        }
      }
    },
    isPCFun: () => {
      let isMobile = window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      ); // 是否手机端
      let isWx = /micromessenger/i.test(navigator.userAgent); // 是否微信
      let isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
      var isDingTalk = /dingtalk/i.test(navigator.userAgent); //是否钉钉
      let PCFlag;
      if (isComWx && isMobile) {
        console.log("手机端企业微信");
        PCFlag = 1;
      } else if (isComWx && !isMobile) {
        console.log("PC端企业微信");
        PCFlag = 2;
      } else if (isWx && isMobile) {
        console.log("手机端微信");
        PCFlag = 3;
      } else if (isMobile && isDingTalk) {
        // console.log("手机端钉钉");
        PCFlag = 4;
      } else if (isDingTalk && !isMobile) {
        // console.log('PC端钉钉');
        PCFlag = 5;
      } else if (!isMobile) {
        // console.log("电脑端");
        PCFlag = 6;
      }
      return PCFlag;
    },
    selectMainType() {
      let url = window.location.href;
      if (
        url.indexOf("mapp") > -1 ||
        url.indexOf("weixiuHome") > -1 ||
        url.indexOf("await_weixiu") > -1
      ) {
        if (window.localStorage.getItem("mainType") == "3") {
          global.$utils.data.set("", "token", "");
        }
        window.localStorage.setItem("mainType", "2");
        return;
      } else if (url.indexOf("uapp") > -1 || url.indexOf("cusIndex") > -1) {
        if (window.localStorage.getItem("mainType") == "2") {
          global.$utils.data.set("", "token", "");
        }
        window.localStorage.setItem("mainType", "3");
        return;
      }
    },
    //截取客户id
    getPar(par) {
      //获取当前URL
      let local_url = window.location.href;
      //获取要取得的get参数位置
      let get = local_url.indexOf(par + "=");
      if (get == -1) {
        return false;
      }
      //截取字符串
      let get_par = local_url.slice(par.length + get + 1);
      //判断截取后的字符串是否还有其他get参数
      let nextPar = get_par.indexOf("&");
      if (nextPar != -1) {
        get_par = get_par.slice(0, nextPar);
      }
      //截取92#/pages/index/index
      if (get_par.indexOf("#") != -1) {
        let arr = get_par.split("#");
        return arr[0];
      }
      window.localStorage.setItem("customerId", parseInt(get_par));
      return get_par;
    },
  },
};
</script>

<style>
.tooltip-dynamic-width {
  max-width: var(--tooltip-width, 50%) !important;
  width: auto !important;
}
html,
body {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  overflow: hidden;
}

.app-main {
  width: 100%;
  height: 100%;
  position: relative;
}

.bottom_a {
  position: fixed;
  bottom: 10px;
  left: 0;
  width: 100%;
  text-align: center;
  color: #adbada;
  font-size: 14px;
  z-index: 1000;
}

.ivu-menu-submenu-title {
  height: 49px !important;
}

.ivu-modal-mask {
  z-index: 1015 !important;
}

.ivu-modal-wrap {
  z-index: 1015 !important;
}

.ivu-poptip-popper {
  z-index: 1060 !important;
}

.el-calendar-table .el-calendar-day {
  padding: 0 !important;
  height: auto !important;
}

.el-calendar__body .el-calendar-table th {
  text-align: center;
}

.el-calendar-table .el-calendar-day:hover {
  background-color: transparent !important;
}

.el-calendar-table td.is-selected {
  background-color: transparent !important;
}

.el-calendar-day .popover_item_hover:hover {
  background-color: #f2f8fe;
}
</style>
